export default __webpack_public_path__ + "src/assets/metamask.75e66549383946ae5ad2207f0fb23578.svg";